import { render, staticRenderFns } from "./form-generator.vue?vue&type=template&id=4a4e65a1&scoped=true&"
import script from "./form-generator.vue?vue&type=script&lang=js&"
export * from "./form-generator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e65a1",
  null
  
)

export default component.exports